import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import { Select, TextField, Typography, Grid, FormControlLabel, Button} from "@mui/material";

export const PageContainer = styled("div")`
    height: 100%;
    overflow: scroll;
    overflow-x: hidden;
    background: linear-gradient(182deg, #E9F9FB 0%, #F1F0FF 96.79%), linear-gradient(110deg, #FFF 0.24%, #E6EAFD 100.46%);
`;

export const Title = styled("div")`
    color: black;
    font-size: 3em;
    font-weight: 800;
    text-align: center;
`;

export const Subtitle = styled("div")`
    color: black;
    font-size: 2em;
    text-align: center;
`;

export const Subtitle2 = styled("div")`
    color: black;
    font-size: 2em;
    text-align: center;
    padding-bottom: 1em;
`;